import { render, staticRenderFns } from "./CargarCartera.vue?vue&type=template&id=219db2d6"
import script from "./CargarCartera.vue?vue&type=script&lang=js"
export * from "./CargarCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports